import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import firebase from "firebase";
import FieldValue = firebase.firestore.FieldValue;
import { TalesParagraph } from "../../../utils/types/TalesParagraph";

export const addHighlight = createAsyncThunk(
  "highlight/add",
  async (highlight: TalesParagraph) => {
    try {
      return await db.collection("highlight").add({
        ...highlight,
        show: `${highlight.show}` === "true",
        creationDate: FieldValue.serverTimestamp(),
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Highlight non aggiunto, ${e.message}`);
    }
  },
);
